module.exports = __webpack_public_path__ + "static/logo-paper-25e1b7fed471aeaa300d7c4a38a9a015.png";